import React from 'react';
import classnames from 'classnames';
import { warning, danger, info } from './styles.mod.scss';

export function Warning({ children, className }) {
  return <div className={classnames(warning, className)}>{children}</div>;
}

export function DangerWarning({ children, className }) {
  return <div className={classnames(danger, className)}>{children}</div>;
}

export function InfoWarning({ children, className }) {
  return <div className={classnames(info, className)}>{children}</div>;
}
